import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {GetAllEmployerBranch, GetEmployerBranchDetails} from "../../redux/selfService/selfServiceSlice";
import PageName from "../../components/PageName";
import LoadingSpinner from "../../components/LoadingSpinner";
import {BsBank} from "react-icons/bs";
import ConfirmEmployer from "./confirm-employer";
import ChangeEmployerBranch from "./ChangeEmployerModal";
import ConfirmationModal from "./ConfirmationModal";

const Employer = ()=>{
    const dispatch = useAppDispatch();
    const [showConfirmEmployer, setShowConfirmEmployer] = useState(false)
    const [showChangeEmployer, setShowChangeEmployer] = useState(false)
    const { employerBranchDetails: branch, isLoading } = useAppSelector((state) => state?.selfService);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const handleConfirmEmployerClick = () => {
        setShowConfirmationModal(true);
      };

      const handleCloseConfirmationModal = () => {
        setShowConfirmationModal(false);
      };


      const handleProceedClick = () => {
        // Perform actions when "Proceed" is clicked
        // For example, display the ConfirmEmployer modal
        setShowConfirmationModal(false); // Close the confirmation modal
        setShowConfirmEmployer(true); // Display the ConfirmEmployer modal
      };
      

    useEffect(()=>{
        dispatch(GetEmployerBranchDetails());
    }, [])

    return (
        <div className="support-page">
            <PageName pageName={"Employer"}/>
            <ChangeEmployerBranch
                showModal={showChangeEmployer}
                onClose={()=>setShowChangeEmployer(false)}
                employer={branch}
            />

{showConfirmationModal && (
  <ConfirmationModal
  showModal={showConfirmationModal}
    onClose={handleCloseConfirmationModal}
    onProceed={handleProceedClick}
  />
)}

            {showConfirmEmployer ?
                <ConfirmEmployer onClose={() => setShowConfirmEmployer(false)}/>
                :
                <>
                    <div className="action-buttons flex justify-end my-12 mx-4">
                        <button className="btn btn-outline" onClick={()=>handleConfirmEmployerClick()}>
                            Employer Confirmation
                        </button>
                        <button className="btn btn-primary ml-4" onClick={()=>setShowChangeEmployer(true)}>
                            Change Employer
                        </button>
                    </div>
                    <div className="account-manager acm">
                        <div className="acm__head">
                            Employer Branch
                        </div>
                        {isLoading ?
                            <LoadingSpinner size={"md"}/>
                            :
                            <div className="acm__body">
                                <div className="acm__img">
                                    <BsBank className="img small"/>
                                </div>
                                <div className="acm__name">
                                    {branch.employerBranchName}
                                </div>
                                <div className="acm__phone">
                                    {branch.employerName}
                                </div>
                                <div className="acm__email">
                                    <a href={`mailto:${branch.email}`}>
                                        {branch.email}
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                </>
            }
        </div>
    )
}

export default Employer;